/**
 * Company Checkbox Dropdown
 *
 * Handles the custom multi-select checkbox dropdown used in
 * RCP registration and EDD checkout forms.
 *
 * @package Arival
 */

jQuery(function($) {
	'use strict';

	// Only initialize if the dropdown exists
	if (!$('.company-dropdown').length) {
		return;
	}

	/**
	 * Toggle dropdown visibility on click
	 */
	$('.company-dropdown .company-input').on('click', function() {
		$('.company-dropdown .dropdown-container ul').slideToggle('fast');
	});

	/**
	 * Hide dropdown when clicking on list item links
	 */
	$('.company-dropdown .dropdown-container ul li a').on('click', function() {
		$('.company-dropdown .dropdown-container ul').hide();
	});

	/**
	 * Close dropdown when clicking outside
	 */
	$(document).on('click', function(e) {
		var $clicked = $(e.target);
		if (!$clicked.closest('.company-dropdown').length) {
			$('.company-dropdown .dropdown-container ul').hide();
		}
	});

	/**
	 * Handle checkbox selection - update display
	 */
	$('.multiSelect input[type="checkbox"]').on('click', function() {
		var title = $(this).data('input-text') + ', ';

		if ($(this).is(':checked')) {
			var html = '<span title="' + title + '">' + title + '</span>';
			$('.selected-checkboxes').show();
			$('.selected-checkboxes').append(html);
			$('.company-placeholder').hide();
		} else {
			$('span[title="' + title + '"]').remove();

			// Show placeholder if no checkboxes selected
			if ($('.multiSelect input[type="checkbox"]:checked').length === 0) {
				$('.selected-checkboxes').hide();
				$('.company-placeholder').show();
			}
		}
	});

	/**
	 * Load existing checked checkboxes on page load
	 */
	$('.multiSelect input[type="checkbox"]').each(function() {
		if ($(this).is(':checked')) {
			var title = $(this).data('input-text') + ', ';
			var html = '<span title="' + title + '">' + title + '</span>';
			$('.selected-checkboxes').show();
			$('.selected-checkboxes').append(html);
			$('.company-placeholder').hide();
		}
	});
});
